import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../styles/About.css";

gsap.registerPlugin(ScrollTrigger);

const clients = [
  {
    name: "Hesham El-Sewedy Trading Co. Ltd",
    meta: "Jeddah, KSA · May 2024 – Present",
    work: "Reporting platforms on SAP ERP with SQL, Power BI and Python, plus Microsoft Fabric and SAP ABAP automation for business stakeholders.",
  },
  {
    name: "Ahmad A. Abed Trading Company",
    meta: "Riyadh, KSA · Aug 2024 – Aug 2026",
    work: "50+ Power BI dashboards across SAP FI, CO, SD, MM, PP and HCM, automated email reporting and alerts, reconciliation checks and CI/CD on GitHub.",
  },
];

const About = () => {
  const aboutRef = useRef(null);
  const textRefs = useRef([]);

  useEffect(() => {
    gsap.fromTo(".about-title",
      {
        y: 30,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: "#about",
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      }
    );

    gsap.from(textRefs.current.filter(Boolean), {
      y: 30,
      opacity: 0,
      duration: 0.8,
      stagger: 0.2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".about-content",
        start: "top 75%",
        toggleActions: "play none none reverse"
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section id="about" ref={aboutRef}>
      <div className="section-header">
        <span className="section-title about-title">About Me</span>
      </div>

      <div className="about-content">
        <div className="about-description">
          <p ref={el => textRefs.current[0] = el}>
            Hi, I'm Mohammed Faizaan Fareed, an <span className="highlight">SAP & Agentic BI Consultant</span>. I help companies running SAP get their data out of spreadsheets and into Power BI dashboards and automated reports their teams actually use.
          </p>

          <p ref={el => textRefs.current[1] = el}>
            I cover the full path: extracting data from <span className="highlight">SAP</span>, modelling, reconciliation and secure publishing in <span className="highlight">Power BI</span>. On top of that I add an agentic layer of <span className="highlight">Python</span> and <span className="highlight">AI</span> that sends reports on schedule, raises data alerts, flags mismatches and validates every release. For my clients, this has cut manual reporting work by up to 70%.
          </p>

          <p ref={el => textRefs.current[2] = el}>
            I build code-first Power BI solutions (PBIP, TMDL, CI/CD) with AI-assisted documentation and validation at <span className="highlight">Brigital</span>. I hold a B.E. in Information Technology from Osmania University.
          </p>
        </div>

        <div className="about-clients" ref={el => textRefs.current[3] = el}>
          <h3 className="about-clients-title">Clients</h3>
          <div className="about-clients-grid">
            {clients.map((client) => (
              <div key={client.name} className="client-card">
                <div className="client-name">{client.name}</div>
                <div className="client-meta">{client.meta}</div>
                <p className="client-work">{client.work}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
